import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Redirect } from 'react-router-dom';

import PageUrls from 'Shared/constants/PageUrls.constants';

import Spinner from 'Shared/components/Spinner';
import { acceptMemberAction } from 'Shared/actions/workspaces';
import { hideSuggestMemberAction } from 'Shared/actions/user';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import Avatar from 'Shared/components/Avatar/Avatar';

import './WorkspaceAcceptMember.scss';

function WorkspaceAcceptMember() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isSaving, setIsSaving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const { slug } = useParams();
  const { showAllUsersInSidebar } = useFlags();

  const member = useDeepEqualSelector(state => state.members.find(m => m.slug === slug));

  const handleCreateClick = async () => {
    try {
      setIsSaving(true);
      const response = await dispatch(acceptMemberAction({ memberSlug: slug }));
      if (response && response.status === 200) {
        history.push(response.data.workspace.path);
      } else {
        setIsSaving(false);
      }
    } catch (e) {
      setIsSaving(false);
    }
  };

  const handleHideClick = async () => {
    try {
      setIsRejecting(true);
      const response = await dispatch(hideSuggestMemberAction({ id: member.id }));
      if (response && response.status === 200) {
        history.push(PageUrls.HOME_PAGE);
      } else {
        setIsRejecting(false);
      }
    } catch (e) {
      setIsRejecting(false);
    }
  };

  if (!showAllUsersInSidebar) return <Redirect to={PageUrls.HOME_PAGE} />;

  return (
    <div className="workspace-accept-member d-flex flex-column justify-content-center align-items-center p-4 w-100">
      <Avatar
        isGradientBorder
        initialsNotSmallSize
        classNames="workspace-accept-member-avatar mb-3"
        avatar={member.avatar}
        height={85}
      />
      <h1 className="workspace-accept-member-title text-center mb-3">
        {`Create a 1:1 workspace with ${member.fullName || member.email}`}
      </h1>
      <div className="workspace-accept-member-description text-center">
        {`Create a private 1:1 workspace for you and ${member.firstName || member.email}`}
      </div>
      <button
        type="button"
        disabled={isSaving || isRejecting}
        className="d-flex btn btn-primary mb-3"
        onClick={handleCreateClick}
      >
        Create Workspace
        <Spinner
          activeIf={isSaving}
          color="#fff"
          spinnerStyles={{ width: '1rem', height: '1rem', borderWidth: '.15rem', marginLeft: '0.5rem' }}
        />
      </button>
      <button
        type="button"
        className="d-flex btn btn-outline-danger border-0 cursor-pointer"
        disabled={isSaving || isRejecting}
        onClick={handleHideClick}
      >
        Hide this teammate from me
        <Spinner
          activeIf={isRejecting}
          color="#D51C54"
          spinnerStyles={{ width: '1rem', height: '1rem', borderWidth: '.15rem', marginLeft: '0.5rem' }}
        />
      </button>
    </div>
  );
}

export default WorkspaceAcceptMember;
